import { useEffect, useState } from 'react'
import { ManualParagraphsResponse } from '../../types/dashboard/manual-paragraphs-response'
import { useGetManuals } from './useGetManuals'
import { useReadManual } from './useReadManual'
import { useRecoilState } from 'recoil'
import { focusIdState } from '../../common/atoms/atoms'

export const scrollTo = (id: string) => {
  const paragraphElement = document.getElementById(id)

  if (paragraphElement) {
    paragraphElement.scrollIntoView({
      behavior: 'smooth',
    })
  }
}

export default function useManual() {
  const [, setFocusId] = useRecoilState(focusIdState)
  const {
    data,
    refetch: getManuals,
    isSuccess: getManualsSuccess,
  } = useGetManuals('1')

  const {
    data: readParagraph,
    mutate: read,
    isSuccess: readSuccess,
  } = useReadManual()

  const [completed, setCompleted] = useState(false)
  const [manuals, setManuals] = useState<ManualParagraphsResponse[]>()

  useEffect(() => {
    if (data) {
      let lastActiveObject
      let index = data.length - 1
      for (; index >= 0; index--) {
        if (data[index].isRead) {
          lastActiveObject = data[index]
          break
        }
      }

      if (lastActiveObject) {
        if (index > -1) {
          setManuals(data.slice(0, index + 2))
        } else {
          setManuals(data.slice(0, 1))
        }
      } else {
        setManuals(data.slice(0, 1))
      }
    }
  }, [data])

  useEffect(() => {
    if (data && data.every((obj) => obj.isRead)) {
      setCompleted(true)
      scrollTo('completed_manual')
      return
    } else {
      setCompleted(false)
    }

    if (manuals && data?.length !== manuals.length) {
      scrollTo(`${manuals[manuals.length - 1].id}`)
      setFocusId(`${manuals[manuals.length - 1].id}`)
    }
  }, [manuals])

  return {
    data,
    read,
    readSuccess,
    readParagraph,
    getManuals,
    getManualsSuccess,
    manuals,
    completed,
  }
}
